export enum SystemParameter {
  countryCodes = "country-codes",
  commissionPercentage = "commission-percentage",
  mapBoxAccessToken = "mapbox-access-token",
  eseyeApiEnabled = "eseye-api-enabled"
}
